import { Injectable } from '@angular/core';
import { Layer, LayerType, NewLayerResponse, NodeFeature, NodeRef, PlotRef } from '@app/shared/models'
import { LayerService, LayersStateService, NodeService, PlotService } from '@app/shared/services';
import { ImusDestroyService } from '@app/shared/services/destroy.service';
import { Observable, tap, forkJoin, concatMap, finalize, takeUntil } from "rxjs";
// import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class LayerEditService {

  private changeObjects: {
    newNodes: NodeRef[], // список точек, которые нужно добавить
    editNodes: NodeRef[],  // список точек, которые нужно отредактировать
    deleteNodes: NodeRef[],  // список точек, которые нужно удалить
    // newLayers: {
    //   layerTypeID: number,
    //   layerName: string
    // }[], // список слоев, которые нужно добавить
    newLayers: Layer[], // список слоев, которые нужно добавить
    editLayers: Layer[],  // список слоев, которые нужно отредактировать
    deleteLayers: number[],  // id слоев, которые нужно удалить
    newPlots: PlotRef[], // список линий, которые нужно добавить
    editPlots: PlotRef[],  // список линий, которые нужно отредактировать
    deletePlots: PlotRef[]  // список линий, которые нужно удалить
  }


  constructor(
    private layerService: LayerService,
    private layerStateService: LayersStateService,
    private nodeService: NodeService,
    private plotService: PlotService,
    private readonly _destroy$: ImusDestroyService
  ) {
    this.changeObjects = {
      newNodes: [],
      editNodes: [],
      deleteNodes: [],
      newLayers: [],
      editLayers: [],
      deleteLayers: [],
      newPlots: [],
      editPlots: [],
      deletePlots: []
    }
  }

  public addNewNode(node: NodeRef) {
    this.changeObjects.newNodes.push(node)
  }

  public addNodeToEdit(node: NodeRef) {
    if (
      !this.changeObjects.newNodes.find((o) => o.id === node.id)
      && !this.changeObjects.editNodes.find((o) => o.id === node.id)
    ) this.changeObjects.editNodes.push(node)
  }

  public addNodeToDelete(node: NodeRef) {
    // console.log('addNodeToDelete')
    let index: number
    index = this.changeObjects.newNodes.findIndex((o) => o.id === node.id)
    if (index >= 0) {
      this.changeObjects.newNodes.splice(index, 1)
    } else {
      index = this.changeObjects.editNodes.findIndex((o) => o.id === node.id)
      if (index >= 0) {
        this.changeObjects.editNodes.splice(index, 1)
      }
      if (!this.changeObjects.deleteNodes.find((o) => o.id === node.id))

        this.changeObjects.deleteNodes.push(node);
    }
  }

  public addNewPlot(plot: PlotRef) {
    this.changeObjects.newPlots.push(plot)
  }

  public addPlotToEdit(plot: PlotRef) {

    if (!this.changeObjects.newPlots.find((o) => o.id === plot.id)) {
      if (!this.changeObjects.editPlots.find((o) => o.id === plot.id))
        this.changeObjects.editPlots.push(plot)

    }

  }

  public addPlotToDelete(plot: PlotRef) {
    // if (!this.changeObjects.deletePlots.find((o) => o.id === plot.id))
    //   this.changeObjects.deletePlots.push(plot)

    let index: number
    index = this.changeObjects.newPlots.findIndex((o) => o.id === plot.id)
    if (index >= 0) {
      this.changeObjects.newPlots.splice(index, 1)
    } else {
      index = this.changeObjects.editPlots.findIndex((o) => o.id === plot.id)
      if (index >= 0) {
        this.changeObjects.editPlots.splice(index, 1)
      }
      if (!this.changeObjects.deletePlots.find((o) => o.id === plot.id))
        this.changeObjects.deletePlots.push(plot);
    }

  }

  public addNewLayer(layerType: LayerType, layerName: string, order?: number) {
    // let layer = new Layer
    let layer = <Layer>{
      name: layerName,
      layer_type: {
        id: layerType.id,
        name: layerType.name
      },
      order: order ?? Math.floor(Math.random() * 99) + 1
    }

    // let layer = new Layer
    // layer.name = layerName;
    // layer.layer_type = {
    //   id : layerTypeID,
    //   name : layerTypeID
    // }
    // layer.order = order??undefined

    this.layerService.add(layer).pipe(
      /** TODO: зачем смотрим на свойство status при статусе 200?? */
      tap((response) => {
        if (response.status !== 'ok') {
          throw new Error(`Ошибка добавления слоя, статус:${response.status}`)
        }
      }),
      takeUntil(this._destroy$)
    ).subscribe((value: NewLayerResponse) => {
      // console.log('layerService.add')
      // console.log(value)
      this.layerService.updateLayerInfo(value.layer_id)
    })

    //Реализация добавления слоев через массив newLayers
    // this.changeObjects.newLayers.push(layer)
    // this.save()
  }

  public addLayerToEdit(layer: Layer) {
    this.changeObjects.editLayers.push(layer)
    this.save().pipe(takeUntil(this._destroy$)).subscribe()
  }

  public editLayer(layer: Layer) {
    this.changeObjects.editLayers.push(layer)
    return this.save()
  }
  public addLayerToDelete(layerID: number) {
    this.changeObjects.deleteLayers.push(layerID)
    this.save().pipe(takeUntil(this._destroy$)).subscribe()
  }

  deleteSelectedNode() {
    // debugger
    let appState = this.layerStateService.getData()
    if (appState.edit && appState.selectedNode && this.layerStateService.hasLayerNode(appState.editableLayerId, appState.selectedNode)) {
      this.addNodeToDelete(appState.getNodeByNodeId(appState.selectedNode))
      // this.addNodeToDelete(this.layerStateService.getNode(appState.selectedNode))
      // appState.deleteNode(appState.selectedNode)
      this.layerStateService.deleteNode(appState.editableLayerId, appState.selectedNode)
    }

    // if (appState.edit && appState.selectedPlotPoint && this.layerStateService.hasLayerPlot(appState.editableLayerId, appState.selectedPlot)) {
    //   // appState.getPlotByPlotId(appState.selectedPlot).coordinates.splice(appState.selectedPlotPoint, 1)
    //   // coordinates.splice(1, 1);
    //   // line.getGeometry().setCoordinates(coordinates);
    // }

  }

  deleteSelectedPlot() {
    // debugger
    let appState = this.layerStateService.getData()
    if (appState.edit && appState.selectedPlot && this.layerStateService.hasLayerPlot(appState.editableLayerId, appState.selectedPlot)) {
      this.addPlotToDelete(appState.getPlotByPlotId(appState.selectedPlot))
      this.layerStateService.deletePlot(appState.editableLayerId, appState.selectedPlot)
    }
  }

  /**
   * "Разворачивает" выбранную линию - Selected Plot
   */
  public turnAroundSelectedPlot() {
    let appState = this.layerStateService.getData()
    if (appState.edit && appState.selectedPlot && this.layerStateService.hasLayerPlot(appState.editableLayerId, appState.selectedPlot)) {
      let plot = appState.getPlotByPlotId(appState.selectedPlot)
      this.layerStateService.turnAroundPlot(plot)
      this.addPlotToEdit(plot)
    }
  }


  public save(layerTypeId?: number) {
    let finishedAll$: Observable<Object>[] = [];
    let finishedAllPlots$: Observable<Object>[] = [];

    // debugger
    let layersToUpdate = new Set<number>([])
    while (this.changeObjects.newLayers.length > 0) {
      let layer = this.changeObjects.newLayers.pop()
      this.layerService.add(layer).pipe(
        /** TODO: зачем смотрим на свойство status при статусе 200?? */
        tap((response) => {
          if (response.status !== 'ok') {
            throw new Error(`Ошибка добавления слоя, статус:${response.status}`)
          }
        }),
        takeUntil(this._destroy$)
      ).subscribe((value: NewLayerResponse) => {
        // console.log('layerService.add')
        // console.log(value)
        this.layerService.updateLayerInfo(value.layer_id)
      })
    }

    while (this.changeObjects.editLayers.length > 0) {
      let layer = this.changeObjects.editLayers.pop()
      finishedAll$.push(this.layerService.editPutLayer(layer))
      layersToUpdate.add(layer.ID)
      // this.layerService.edit(layer.layerName, layer.layerTypeID).subscribe((value: Record<any, any>) => {
      //   // console.log('layerService.edit')
      //   // console.log(value)
      // })
    }

    while (this.changeObjects.deleteLayers.length > 0) {
      let layerID = this.changeObjects.deleteLayers.pop()
      finishedAll$.push(this.layerService.delete(layerID))
      // this.layerService.delete(layerID).subscribe(value => {
      //   // console.log('layerService.delete')
      //   // console.log(value)
      //   // return value
      // })
    }

    while (this.changeObjects.newNodes.length > 0) {
      let node = this.changeObjects.newNodes.pop()
      finishedAll$.push(this.nodeService.add(node.getNodeReq()).pipe(
        tap(responce => {
          // node.id = (responce as node.NodeData).data.properties.id
          // node.id = (responce as node.NodeData).properties.id
          node.id = (responce as NodeFeature).properties.id
        })
      )
        //   .subscribe(value => {
        //   // console.log('nodeService.add')
        //   // console.log(value)
        //   if (!layersToUpdate.find(x => x == node.layer))
        //     layersToUpdate.push(node.layer)
        //   // return value
        // })
      )
      layersToUpdate.add(node.layer)
    }

    while (this.changeObjects.editNodes.length > 0) {
      if (this.changeObjects.deleteNodes.length > 0) {
        this.changeObjects.deleteNodes.map(node => {
          let index = this.changeObjects.editNodes.findIndex((o) => o.id === node.id)
          if (index >= 0) {
            this.changeObjects.editNodes.splice(index, 1)
          }
        })
      }

      let node = this.changeObjects.editNodes.pop()
      if (node) {
        finishedAll$.push(this.nodeService.editPut(<number>node.id, node.getNodeReq()))
        layersToUpdate.add(node.layer)
      }
    }

    while (this.changeObjects.deleteNodes.length > 0) {
      let node = this.changeObjects.deleteNodes.pop()
      finishedAll$.push(this.nodeService.delete(<number>node.id))
      layersToUpdate.add(node.layer)
    }

    /** Plot section start */
    if (finishedAll$.length == 0) {
      while (this.changeObjects.newPlots.length > 0) {
        let plot = this.changeObjects.newPlots.pop()
        finishedAll$.push(this.plotService.add(plot))
        layersToUpdate.add(plot.layer)

      }
    }

    while (this.changeObjects.editPlots.length > 0) {
      if (this.changeObjects.deletePlots.length > 0) {
        this.changeObjects.deletePlots.map(plot => {
          let index = this.changeObjects.editPlots.findIndex((o) => o.id === plot.id)
          if (index >= 0) {
            this.changeObjects.editPlots.splice(index, 1)
          }
        })
      }

      let plot = this.changeObjects.editPlots.pop()
      if (plot && typeof plot.id == 'number') {
        // console.log(plot)
        finishedAll$.push(this.plotService.editPut(plot.getPlotReq(), <number>plot.id))
        layersToUpdate.add(plot.layer)
      }
    }

    while (this.changeObjects.deletePlots.length > 0) {
      let plot = this.changeObjects.deletePlots.pop()
      finishedAll$.push(this.plotService.delete(<number>plot.id))
      layersToUpdate.add(plot.layer)
    }

    /** Plot section end */

    // if (finishedAll$.length > 0) {
    return forkJoin(finishedAll$).pipe(
      tap(_ => {
        while (this.changeObjects.newPlots.length > 0) {
          let plot = this.changeObjects.newPlots.pop()
          finishedAllPlots$.push(this.plotService.add(plot))
          layersToUpdate.add(plot.layer)
        }
      }),
      concatMap(_ => forkJoin(finishedAllPlots$)),

      finalize(() => {
        // console.log('finalize save', layersToUpdate)
        layersToUpdate.forEach(layerId => this.layerService.updateLayerInfo(layerId))
        layersToUpdate.clear()
      })
    )

  }

}
